/**
 * @file 文档正文
 * @author Wanzhongyun
 */
import React, { forwardRef } from 'react';
import classNames from 'classnames';

import { DocumentArticleProps } from './type';

const DocArticle = forwardRef<HTMLDivElement, DocumentArticleProps>((props, ref) => {
    return (
        <div
            ref={ref}
            className={classNames('paddle-doc-page-content', 'markdown-body')}
            {...{ dangerouslySetInnerHTML: { __html: props.article } }}
        />
    );
});

export default DocArticle;
